<template lang="html">
    <div class="box-email">
      <div class="text-xs-center info-hotsite">
        Foi enviado um e-mail para <span class="email">{{ email }}</span>, confirme seu e-mail para prosseguir com o pedido.
      </div>
    </div>
</template>

<script>
export default {
  name: 'confirm',
  computed: {
    email () {
      return this.$store.getters.email
    }
  },
  mounted () {
    if (this.email === '') {
      this.$router.push('/a/')
    }
  }
}
</script>

<style lang="css">
.box-email{
  background: #fff;
  width: 320px;
  margin: auto;
  padding: 20px;
  margin-top: 20px;
  border-radius: 20px;
}
.email{
  color: #009865
}
</style>



// WEBPACK FOOTER //
// Confirm.vue?4fdd5bb4